
import React from "react";
import { TrendingUp } from "lucide-react";
import { useNavigate } from "react-router-dom";

const GlassmorphicFooter = () => {
  const navigate = useNavigate();
  
  const footerLinkColumns = [
    {
      title: "Company Info",
      links: [
        { name: "About Us", href: "#" },
        { name: "Careers", href: "#" },
        { name: "Contact", href: "#" },
        { name: "Blog", href: "#" },
      ]
    },
    {
      title: "Resources",
      links: [
        { name: "Help Center", href: "#" },
        { name: "Case Studies", href: "#" },
      ]
    },
    {
      title: "Legal",
      links: [
        { name: "Terms of Service", href: "#" },
        { name: "Privacy Policy", href: "#" },
        { name: "GDPR Compliance", href: "#" },
        { name: "Cookie Policy", href: "#" },
      ]
    },
    {
      title: "Connect",
      links: [
        { name: "Twitter", href: "#" },
        { name: "LinkedIn", href: "#" },
        { name: "YouTube", href: "#" },
        { name: "Instagram", href: "#" },
      ]
    }
  ];
  
  return (
    <footer className="bg-[#272727] text-[#FCFDFD] pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1 mb-8 lg:mb-0">
            <div 
              className="flex items-center gap-2 cursor-pointer mb-4" 
              onClick={() => navigate("/")}
            >
              <TrendingUp className="h-6 w-6 text-[#FCFDFD]" />
              <span className="font-bold text-xl text-[#FCFDFD]">Keyword OS</span>
            </div>
            <p className="text-[#FCFDFD]/80 mb-6 text-sm">
              Powerful keyword research tools.
            </p>
            <p className="text-sm text-[#FCFDFD]/70">
              © {new Date().getFullYear()} Keyword OS. All rights reserved.
            </p>
          </div>
          
          {footerLinkColumns.map((column, colIndex) => (
            <div key={colIndex}>
              <h3 className="font-semibold text-[#FCFDFD] mb-4">{column.title}</h3>
              <ul className="space-y-3">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.href} 
                      className="text-[#FCFDFD]/90 hover:text-[#FCFDFD] hover:underline transition-colors text-sm"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default GlassmorphicFooter;
